import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MyDropdown from "./MyDropdown.vue";
import sortBy from "lodash/sortBy";
import lang from "iso-639-1";
import { computed, ref } from "vue";
import { LanguageInfo } from "@/LanguageInfo";
import { availableLanguages } from "@/language";


export default /*#__PURE__*/_defineComponent({
  emits: ["selected"],
  setup(__props, { emit }) {

const current = ref(null);


function onSelected(item:LanguageInfo) {
  emit("selected", item);
}

const languageCodes = ref(availableLanguages);

const languages = computed(() => {
  let codes = languageCodes.value;
  let result:LanguageInfo[] = [];
  for (const code of codes) {
    let info = new LanguageInfo(code, lang.getName(code))
    result.push(info);
  }
  let sorted = sortBy(result, (x) => x.name);
  sorted.unshift({
    code: "auto",
    name: "auto",
  });
  return sorted;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyDropdown, {
    list: _unref(languages),
    current: current.value,
    onSelected: onSelected
  }, null, 8, ["list", "current"]))
}
}

})